import React, { useCallback, useContext, useEffect, useState } from "react";

import { toast } from "react-toastify";
import api from "../../services/api";
import toastError from "../../errors/toastError";

import {
  Box,
  Button,
  Dialog,
  DialogActions,
  makeStyles,
} from "@material-ui/core";
import { useHistory } from "react-router-dom";
import { AuthContext } from "../../context/Auth/AuthContext";
import MessagesList from "../MessagesList";
import { ReplyMessageProvider } from "../../context/ReplyingMessage/ReplyingMessageContext";
import { ForwardMessageProvider } from "../../context/ForwarMessage/ForwardMessageContext";

import TicketHeader from "../TicketHeader";
import TicketInfo from "../TicketInfo";

import html2pdf from "html2pdf.js";

const drawerWidth = 320;

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    height: "100%",
    position: "relative",
    overflow: "hidden",
  },

  mainWrapper: {
    flex: 1,
    height: "100%",
    display: "flex",
    flexDirection: "column",
    overflow: "hidden",
    borderTopLeftRadius: 0,
    borderBottomLeftRadius: 0,
    borderLeft: "0",
    marginRight: -drawerWidth,
    transition: theme.transitions.create("margin", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
  },

  mainWrapperShift: {
    borderTopRightRadius: 0,
    borderBottomRightRadius: 0,
    transition: theme.transitions.create("margin", {
      easing: theme.transitions.easing.easeOut,
      duration: theme.transitions.duration.enteringScreen,
    }),
    marginRight: 0,
  },
}));

export default function TicketMessagesDialog({ open, handleClose, ticketId }) {
  const history = useHistory();
  const classes = useStyles();

  const { user, socket } = useContext(AuthContext);

  const [, setDrawerOpen] = useState(false);
  const [loading, setLoading] = useState(true);
  const [contact, setContact] = useState({});
  const [ticket, setTicket] = useState({});

  const [exportedToPDF, setExportedToPDF] = useState(false);

  // ----------------------- PATRICK -----------------------

  function convertImagesToBase64(container) {
    const images = container.querySelectorAll("img");
    const promises = [];

    images.forEach((img) => {
      if (!img.src.startsWith("data:")) {
        promises.push(
          new Promise((resolve) => {
            const canvas = document.createElement("canvas");
            const ctx = canvas.getContext("2d");
            canvas.width = img.naturalWidth;
            canvas.height = img.naturalHeight;

            const tempImg = new Image();
            tempImg.crossOrigin = "anonymous"; // evita erro CORS
            tempImg.src = img.src;

            tempImg.onload = () => {
              ctx.drawImage(tempImg, 0, 0, canvas.width, canvas.height);
              img.src = canvas.toDataURL("image/png"); // substitui pelo base64
              resolve();
            };

            tempImg.onerror = () => resolve(); // mesmo se falhar, segue
          })
        );
      }
    });

    return Promise.all(promises);
  }
  // ----------------------- PATRICK -----------------------
  // Remove estilos puramente visuais (animações de destaque, efeito de
  // vidro) que não fazem sentido num PDF estático e que o parser de CSS
  // do html2canvas pode falhar ao interpretar em alguns casos.
  function sanitizeCloneForExport(clone) {
    const elements = [clone, ...clone.querySelectorAll("*")];
    elements.forEach((el) => {
      if (!el.style) return;
      el.style.transform = "";
      el.style.backdropFilter = "";
      el.style.webkitBackdropFilter = "";
    });
  }
  // ----------------------- PATRICK -----------------------
  const handleExportToPDF = async () => {
    const messagesListElement = document.getElementById("messagesList");
    const headerElement = document.getElementById("TicketHeader");

    const pdfOPtions = {
      margin: 1,
      filename: `relatório_atendimento_${ticketId}.pdf`,
      image: { type: "jpeg", quality: 0.98 },
      html2canvas: { scale: 2, useCORS: true, allowTaint: true },
      jsPDF: { unit: "mm", format: "a4", orientation: "portrait" },
    };

    if (messagesListElement) {
      try {
        // 🔹 Converte imagens no DOM ORIGINAL antes de clonar
        await convertImagesToBase64(messagesListElement);

        // Agora sim clona os elementos já com imagens em base64
        const headerClone = headerElement.cloneNode(true);
        const messagesListClone = messagesListElement.cloneNode(true);

        sanitizeCloneForExport(headerClone);
        sanitizeCloneForExport(messagesListClone);

        const containerElement = document.createElement("div");
        containerElement.appendChild(headerClone);
        containerElement.appendChild(messagesListClone);

        await html2pdf().from(containerElement).set(pdfOPtions).save();
      } catch (err) {
        console.error("Erro ao exportar PDF:", err);
        toastError("Não foi possível gerar o PDF. Tente novamente.");
      }
    } else {
      toastError("Elemento não encontrado para exportar.");
    }
  };

  const handleExportAndClose = () => {
    if (!exportedToPDF) {
      handleExportToPDF();
      setExportedToPDF(true);
      handleClose(); // Fecha o Dialog
    }
  };

  useEffect(() => {
    if (open) {
      // Execute a exportação para PDF e feche o Dialog
      handleExportAndClose();
    }
  }, [open, ticketId, handleExportAndClose]);

  return (
    <Dialog maxWidth="md" onClose={handleClose} open={open}>
      <DialogActions>
        <Button onClick={handleExportToPDF} color="primary">
          Exportar para PDF
        </Button>
        <Button onClick={handleClose} color="primary">
          Fechar
        </Button>
      </DialogActions>
    </Dialog>
  );
}
